import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue'
import store from '@/store/store'
import { ModuleNamespaces } from '@/store/types/storeGlobalTypes'
import { useI18n } from 'vue-i18n-composable'
import CustomDialogActionButtonsComponent from '@/components/Dialog/CustomDialog/CustomDialogActionButtonsComponent.vue'
import CustomDialogHeaderComponent from '@/components/Dialog/CustomDialog/CustomDialogHeaderComponent.vue'

interface InternalMessage {
  de: string
  para: string
  asunto: string
  cuerpo: string
  fecha: string | Date
}


export default /*#__PURE__*/_defineComponent({
  __name: 'InternalMessageDetailDialogComponent',
  props: {
    componentProps: { type: Object, required: true }
  },
  setup(__props: any) {

const props = __props as {
  componentProps: { context: string; message: InternalMessage }
};



const { t } = useI18n()

const TEXT = {
  title: t('components.notifications.title'),
  accept: t('action_buttons.accept'),
  from: t('components.notifications.from'),
  to: t('components.notifications.to')
}

const dialogModule: string = ModuleNamespaces.DIALOG

const formattedDate = computed(() => {
  if (!props.componentProps.message.fecha) return ''

  const date =
    typeof props.componentProps.message.fecha === 'string'
      ? new Date(props.componentProps.message.fecha)
      : props.componentProps.message.fecha

  const options: Intl.DateTimeFormatOptions = {
    weekday: 'long',
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  }

  const dateStr = date.toLocaleDateString('es-ES', options)
  const timeStr = date.toLocaleTimeString('es-ES', { hour: '2-digit', minute: '2-digit' })

  // Formato: "Lunes 12/03/2024 19:22h"
  const weekday = dateStr.split(' ')[0].replace(',', '')
  const formattedWeekday = weekday.charAt(0).toUpperCase() + weekday.slice(1)

  return `${formattedWeekday} ${date.getDate().toString().padStart(2, '0')}/${(date.getMonth() + 1)
    .toString()
    .padStart(2, '0')}/${date.getFullYear()} ${timeStr}h`
})

const handleAccept = () => {
  store.dispatch(`${dialogModule}/closeCustomDialog`)
}

return { __sfc: true,props, t, TEXT, dialogModule, formattedDate, handleAccept, CustomDialogActionButtonsComponent, CustomDialogHeaderComponent }
}

})